import { Injectable } from '@angular/core';
import { CoreService } from '../../../core/core.service';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class EnergyProgramService {

constructor(private coreService: CoreService) { }


SaveEnergyProgramData(tc) {
return this.coreService.post('Forms/SaveEnergyProgram/', tc);

}
// saveRatebookData(postdata) {
//     return this.coreService.post('Ratebook/SaveTaxTables/', postdata);
//   }
}

